import { Action } from 'redux';
import { OnExchangeEligibilityFormStateStructure } from '../../angular-elements/shared/interfaces/on-exchange-eligibility-form.interface';


const INITIAL_STATE: OnExchangeEligibilityFormStateStructure = {
  marketplaceReviewApplication: {},
  marketplaceAdvancePremiumTaxCredit: {
    attestation: false,
    primaryTaxFiler: '',
    jointTaxFiler: ''
  },
  marketplaceNotificationAndAuthorization: {
    attestation: false,
  },
  marketplaceProducerAuthorization: {
    attestation: false
  },
  marketplaceConsumerNpn: {
    workingWithProducerIndicator: false,
    producerFirstName: '',
    producerLastName: '',
    npn: '',
    verifyNpn: ''
  }
};

class OnExchangeEligibilityFormAction implements Action {
  type: string;
  onExchangeEligibilityForm?: OnExchangeEligibilityFormStateStructure;
}

export const ON_EXCHANGE_ELIGIBILITY_FORM_REDUCER_NAME = 'onExchangeEligibilityForm';
export function onExchangeEligibilityForm(
  state: OnExchangeEligibilityFormStateStructure = INITIAL_STATE,
  action: OnExchangeEligibilityFormAction
) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    default:
      return state;
  }
}

